"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LOWEST_PRICE = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _SelectInput = require("@oberoninternal/travelbase-ds/components/form/SelectInput");
var _useThemeContext = require("@oberoninternal/travelbase-ds/hooks/useThemeContext");
var _Cross = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/figure/Cross"));
var _Package = _interopRequireDefault(require("@oberoninternal/travelbase-ds/svg/Package.svg"));
var _grid = require("@rebass/grid");
var _lodash = _interopRequireDefault(require("lodash.isequal"));
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _reactLoadingSkeleton = _interopRequireDefault(require("react-loading-skeleton"));
var _searchParams = _interopRequireDefault(require("../constants/searchParams"));
var _graphql = require("../generated/graphql");
var _StyledCaret = _interopRequireDefault(require("./designsystem/StyledCaret"));
var _Tag = _interopRequireDefault(require("./svg/Tag.svg"));
var _useQueryParams = _interopRequireDefault(require("../hooks/useQueryParams"));
var _client = require("@apollo/client");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __jsx = _react.default.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// TODO: Ask BE for a specials query with ids as a param
const useSpecialsQuery = ids => {
  const client = (0, _client.useApolloClient)();
  const {
    0: state,
    1: setState
  } = (0, _react.useState)({
    loading: true,
    data: null
  });
  const idsRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    if (!(0, _lodash.default)(idsRef.current, ids)) {
      const requests = [];
      for (const id of ids) {
        if (!id) {
          break;
        }
        requests.push(client.query({
          query: _graphql.SpecialDocument,
          variables: {
            id
          }
        }));
      }
      Promise.all(requests).then(data => setState({
        loading: false,
        data: data.map(result => result.data.special).filter(result => !!result)
      })).catch(err => {
        // eslint-disable-next-line no-console
        console.error(err);
      });
      idsRef.current = ids;
    }
  }, [client, ids]);
  return state;
};
const LOWEST_PRICE = exports.LOWEST_PRICE = 'lowest_price';
const SpecialFilterInput = /*#__PURE__*/(0, _react.forwardRef)(({
  specialIds,
  beforeOnChange
}, ref) => {
  const theme = (0, _useThemeContext.useThemeContext)();
  const intl = (0, _reactIntl.useIntl)();
  const defaultOption = {
    label: intl.formatMessage({
      "id": "+qkTpl",
      "defaultMessage": [{
        "type": 0,
        "value": "Laagste prijs"
      }]
    }),
    value: LOWEST_PRICE,
    icon: __jsx(_Tag.default, {
      className: "gt-s",
      width: 18,
      height: 18
    })
  };
  const [{
    specialId = defaultOption.value
  }, setParams] = (0, _useQueryParams.default)(_searchParams.default);
  const {
    data,
    loading
  } = useSpecialsQuery(specialIds.concat(specialIds.every(id => id !== specialId) && specialId !== defaultOption.value ? [specialId] : []));
  if (loading) {
    return __jsx(_grid.Box, {
      width: "30rem",
      height: "2rem"
    }, __jsx(_reactLoadingSkeleton.default, {
      width: "100%",
      height: "100%"
    }));
  }
  const options = [defaultOption, ...(data ? data.map(special => ({
    label: special.name,
    value: special.id,
    icon: __jsx(_Package.default, null)
  })) : [])];
  const Toggle = () => specialId !== defaultOption.value ? __jsx(_Cross.default, {
    width: 10,
    height: 10,
    style: {
      marginRight: '0.4rem',
      cursor: 'pointer'
    },
    onTouchEnd: e => {
      e.preventDefault();
      e.stopPropagation();
      setParams({
        specialId: undefined
      }, 'replaceIn');
    },
    onMouseDown: e => {
      e.preventDefault();
      e.stopPropagation();
      setParams({
        specialId: undefined
      }, 'replaceIn');
    }
  }) : __jsx(_StyledCaret.default, null);
  if (options.length <= 1) {
    return null;
  }
  return __jsx(_grid.Box, {
    width: [1, null, '20rem', '30rem'],
    ref: ref
  }, __jsx(_SelectInput.SelectInputField, {
    onChange: option => {
      if (specialId !== option.value) {
        beforeOnChange?.();
      }
      setTimeout(() => setParams({
        specialId: option.value === LOWEST_PRICE ? undefined : option.value
      }, 'replaceIn')); // 😔
    },
    styles: {
      singleValue: (styles, {
        data: {
          value
        }
      }) => _objectSpread(_objectSpread({}, styles), {}, {
        fontWeight: value !== defaultOption.value ? 400 : styles.fontWeight,
        color: value !== defaultOption.value ? theme.colors.neutral['90'] : styles.color
      }),
      dropdownIndicator: (base, state) => _objectSpread(_objectSpread({}, base), {}, {
        color: state.isDisabled ? theme.colors.neutral['20'] : state.isFocused ? theme.colors.neutral['90'] : theme.colors.neutral['40'],
        '&:hover': {
          color: theme.colors.neutral['80']
        }
      })
    },
    isDisabled: options.length === 1,
    hideChoices: true,
    value: options.find(option => option.value === specialId) ?? options[0],
    thinShadow: true,
    rounded: true,
    options: options,
    ToggleComponent: Toggle
  }));
});
var _default = exports.default = SpecialFilterInput;